import angular from "angular";

import "angular-pageslide-directive";

export default angular
  .module("controllers.application", [
    "pageslide-directive",
  ])
  .controller("ApplicationController", [
    function() {
      this.isMenuOpen = false;

      this.toggleMenu = function() {
        this.isMenuOpen = !this.isMenuOpen;
      };
    },
  ])
  .name;



// WEBPACK FOOTER //
// ./app/web/packs/angular/controllers/application-controller.js